<template>
  <div class="newPayment">
    <img
      @click="$emit('closeDialog')"
      class="close-icon"
      src="../../assets/icons/close.png"
      alt="Close"
    >
    <v-container>
      <h1 class="header-text">
        <span>Nova uplata
          <div class="header-text-line"></div>
        </span>
      </h1>
      <v-form v-model="valid">
        <v-layout row wrap>
          <v-flex xs5>
            <v-select label="Godina" :rules="rules.required" v-model="payment.Year" :items="years"></v-select>
          </v-flex>
          <v-flex xs5 offset-xs2>
            <v-select
              label="Mjesec"
              v-model="payment.Month"
              :items="months"
              :rules="rules.required"
              item-text="Name"
              item-value="Id"
            ></v-select>
          </v-flex>

          <v-flex xs12>
            <v-text-field :rules="rules.required" label="Količina" v-model="payment.Quantity"></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-autocomplete
              v-model="payment.UserId"
              :items="attendends"
              :loading="isLoading"
              :search-input.sync="attendendsSearch"
              chips
              clearable
              hide-details
              :rules="rules.required"
              hide-selected
              item-text="Name"
              item-value="UserId"
              label="Članarina za korisnika..."
              solo
            >
              <template slot="no-data">
                <v-list-tile>
                  <v-list-tile-title>Pretraga korisnika</v-list-tile-title>
                </v-list-tile>
              </template>
              <template slot="selection" slot-scope="{ item, selected }">
                <v-chip :selected="selected" color="blue-grey" class="white--text">
                  <img :src="item.ProfileUrl" class="exstra-small-profile" alt="User profile image">
                  <span v-text="item.Name"></span>
                </v-chip>
              </template>
              <template slot="item" slot-scope="{ item, tile }">
                <img :src="item.ProfileUrl" class="small-profile" alt="User profile image">
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.Name"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 class="text-right actions">
            <v-btn :disabled="!valid" class="main-btn" @click="submitPayment">Spremi</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>
export default {
  props: ["years", "months"],
  data() {
    return {
      payment: {
        Year: null,
        Month: null,
        Quantity: 30
      },
      attendends: [],
      isLoading: false,
      attendendsSearch: null,
      valid: false,
      rules: {
        required: [v => !!v || "Polje je obavezno"]
      }
    };
  },
  methods: {
    fillYears() {
      var today = new Date();
      var currentYear = today.getFullYear();
      var i = currentYear - 2;
      for (i; i < currentYear + 10; i++) {
        this.years.push(i);
      }
      this.payment.Year = currentYear;

      //Select current month - 1
      this.payment.Month = this.months[today.getMonth() - 1].Id;
    },
    selectMonthAndYear() {
      var today = new Date();
      var currentYear = today.getFullYear();
      this.payment.Year = currentYear;

      //Select current month - 1
      this.payment.Month = this.months[today.getMonth() - 1].Id;
    },
    getAttendends() {
      this.$store.state.services.userService
        .attendendsList()
        .then(response => {
          this.attendends = response.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    submitPayment() {
      this.$store.state.services.membershipFeeService
        .add(this.payment)
        .then(response => {
          this.$store.dispatch("setResponseMessage",response.data);
          this.$emit("closeDialog");
          this.$emit("refreshData");
          this.payment.UserId = null;
          this.selectMonthAndYear();
        });
    }
  },
  created() {
    this.selectMonthAndYear();
  },
  watch: {
    attendendsSearch() {
      //TODO -> optimize with search by name if possible
      if (this.attendends.length > 0) {
        return;
      }
      this.isLoading = true;
      this.getAttendends();
    }
  }
};
</script>

<style scoped>
.newPayment {
  position: relative;
}
.header-text {
  margin-bottom: 20px;
}
.small-profile {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
  display: inline-block;
}
.exstra-small-profile {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 5px;

}
.actions {
  padding-top: 20px;
}
</style>
